/**
 *
 */
import BaseComponent from '../basecomponent/index.js';
import Hammer from 'hammerjs';
import Util, { mergeOption, resizeObserver, curryDebounce, curryThrottle } from '../../util/index.js';
import { Conf } from '../config';
// import KLINE_STATE from '../kline'; // K线
import KLINE_US_STATE from '../klineusmap'; // k线美国线
import KLINE_AREA_STATE from '../klineclosearea'; // k线收盘价面积图
import KLINE_LINE_STATE from '../klinecloseline'; // k线收盘价折线图
import KLINE_CLOSELINE_STATE from '../klinecloseline'
import {
  NET_STATUS
} from '../index';
import {
  ERROR_TYPE
} from '../setting.js';
import loadingIcon from '../../assets/image/load.gif';
const { LOADING, ERROR, LOADED } = NET_STATUS;
/**** 错误信息 ****/
const { ERROR_TEXT, ERROR_IMAGE } = ERROR_TYPE;
import Matrix2d from '../../math/matrix2d/index.js';
const floatCeil = n => {
  return ~~n;
};
const floatFloor = n => {
  return Math.floor(n);
};

export default class Component extends BaseComponent {
  constructor(ele, args = {}) {
    const { parent, ...option } = args;
    const { graphConfig } = option.store.state
    super(option);
    this.parent = parent;
    this.ele = Util.isString(ele) ? document.querySelector(ele) : ele;
    this.option = mergeOption({}, Conf.Component, option, graphConfig.Component || {});
    this.dpr = 2;
    this.resizeObserve = null;
    this.changeHandler = null;
    this.currySwipe = null;
    this.hammerManager = null;
    this.state = {
      realCanvas: null,
      realCursorCanvas: null,
      realContext: null,
      realCursorContext: null,
      mainView: null,
      mainCursorView: null,
      mainViewArea: {
        left: 0,
        right: 0,
        width: 0,
        height: 0
      },
      footView: null,
      footCursorView: null,
      footViewArea: {
        left: 0,
        right: 0,
        width: 0,
        height: 0
      },
      pageX: 0,
      pageY: 0,
      ratio: 0.04,
    };
    [
      '_init',
      '_initGestures',
      '_watch',
      '_resize',
      '_loading',
      '_loadErr',
      '_calcOffset',
      '_panEvent',
      '_pressEvent',
      '_tapEvent',
      '_hideCursor',
      '_showCursor',
      '_swipe',
      'observeSwipe',
      'observeStatus',
      '_mouseMove',
      '_mouseLeave',
      'changeMainView',
      'changeFootView',
      'destroy',
    ].forEach(method => {
      this[method] = this[method].bind(this);
    });
    this._init();
    this._watch();
  }
  _init() {
    let realCanvas = document.createElement('canvas');//大图
    realCanvas.style.position = 'absolute';
    realCanvas.style.left = 0;
    realCanvas.style.top = 0;
    realCanvas.id = 'FOOT'
    // realCanvas.style.zIndex = 1;
    this.state.realCanvas = realCanvas;
    this.state.realContext = realCanvas.getContext('2d');
    let realCursorCanvas = document.createElement('canvas');
    realCursorCanvas.style.position = 'absolute';
    realCursorCanvas.style.zIndex = 2;
    realCursorCanvas.style.left = 0;
    realCursorCanvas.style.top = 0;
    realCursorCanvas.style.opacity = 0.9;
    this.state.realCursorCanvas = realCursorCanvas;
    this.state.realCursorContext = realCursorCanvas.getContext('2d');
    this._initGestures();

    this.currySwipe = curryThrottle(this._swipe, this, 10);
    // 切换TAB时，待_resize后再调用changeMainView和changeFootView
    // 防止因size变化引起闪屏
    this.changeHandler = curryDebounce(() => {
      this.changeMainView();
      this.changeFootView();
    }, this, 50);
    this.resizeObserve = resizeObserver(this._resize);
    this.resizeObserve.observe(this.ele);
    this.ele.appendChild(realCanvas);
    this.ele.appendChild(realCursorCanvas);
    document.oncontextmenu = function() {
      return false;
    };
  }
  _initGestures(option) {
    if (this.hammerManager) {
      this.hammerManager.destroy();
      this.hammerManager = null;
    }
    if (this.option.supportHammer) {
      if (option) {
        this.option.hammerOption = mergeOption({}, Conf.Component.hammerOption, option);
      }
      this.hammerManager = new Hammer.Manager(this.state.realCursorCanvas, this.option.hammerOption || {});
      if (this.option.hammerOption.panAble) {
        this.hammerManager.add(new Hammer.Pan({ direction: this.option.hammerOption.pan.direction }));
        this.hammerManager.on('panmove', this._panEvent);
        this.hammerManager.on('pancancel', this._panEvent);
        this.hammerManager.on('panend', this._panEvent);

      }
      if (this.option.hammerOption.pressAble) {
        this.hammerManager.add(new Hammer.Press());
        this.hammerManager.on('press', this._pressEvent);
        this.hammerManager.on('pressup', this._pressEvent);
      }
      if (this.option.hammerOption.tapAble) {
        this.hammerManager.add(new Hammer.Tap());
        this.hammerManager.on('tap', this._tapEvent);
      }
    }
  }
  _watch() {
    /**
     * 画布状态切换
     */
    this.store.watch({
      key: 'status',
      fn: this.observeStatus
    });
    /**
     * 用作无加载动画刷新画布
     */
    this.store.watch({
      key: 'timeStamp',
      fn: this.observeStatus,
      expression: () => {
        return this.store.state.status === LOADED;
      }
    });
    /**
     * 除复权切换时刷新K线图
     */
    this.store.watch({
      key: 'klineStatus',
      fn: this.observeStatus,
      expression: () => {
        return this.store.state.status === LOADED;
      }
    });
    /**
     * k线不同类型切换
     */
    this.store.watch({
      key: 'kLineMapKey',
      fn: this.changeMainView,
      expression: () => {
        return this.store.state.status === LOADED;
      }
    });
    /**
     * 视图context切换
     * 作为手势切换时触发
     */
    this.store.watch({
      key: 'mainContextKey',
      fn: this.changeMainView,
      expression: () => {
        return this.store.state.status === LOADED;
      }
    });
    this.store.watch({
      key: 'footContextKey',
      fn: this.changeFootView,
      expression: () => {
        return this.store.state.status === LOADED;
      }
    });
    /**
     * 手势左右滑动
     * expression进行表达式判断
     * 避免切换period时重置start和end而导致重复渲染视图
     */
    this.store.watch({
      key: ['start', 'end'],
      fn: this.observeSwipe,
      expression: () => {
        return this.store.state.status === LOADED;
      }
    });
    this.store.watch({
      key: ['pageX', 'pageY'],
      fn: this._mouseMove,
      expression: () => {
        return this.store.state.status === LOADED;
      }
    })
    this.store.watch({
      key: ['pageX'],
      fn: this._mouseLeave,
      expression: () => {
        return this.store.state.status === LOADED;
      }
    })
    /**
     * 调整手势option
     */
    this.store.watch({
      key: ['isVertical', 'isFullScreen'],
      fn: this.observeGestures,
      context: this
    })
  }
  _mouseMove() {
    this._validEvent() && this._validEvent().then(r => {
      this._showCursor(r);

    }).catch(err => {
      this._hideCursor();
    });
  }
  _mouseLeave() {
    if (!this.store.state.pageX) {
      this._hideCursor()
    }
  }
  _resize(entry) {
    if (entry.contentRect) {
      let { realCanvas, realCursorCanvas, realContext, realCursorContext } = this.state;
      let { width, height } = entry.contentRect;
      if (!width || !height) {
        return;
      }
      const _w = width * this.dpr;
      const _h = height * this.dpr;
      realCanvas.style.width = width + 'px';
      realCanvas.style.height = height + 'px';
      realCanvas.width = _w;
      realCanvas.height = _h;
      if (realCursorCanvas) {
        realCursorCanvas.style.width = width + 'px';
        realCursorCanvas.style.height = height + 'px';
        realCursorCanvas.width = _w;
        realCursorCanvas.height = _h;
      }
      const { baseSize, status, isFullScreen } = this.store.state;
      const { left: mainLeft, right: mainRight, top: mainTop, bottom: mainBottom } = isFullScreen ? this.option.mainFullViewOption : this.option.mainViewOption;
      this.state.mainViewArea = {
        baseSize,
        isFullScreen,
        left: floatCeil(_w * mainLeft),
        top: floatCeil(_h * mainTop),
        width: floatCeil(_w * (1 - mainLeft - mainRight)),
        height: floatFloor(_h * (1 - mainTop - mainBottom))
      };
      const { left: footLeft, right: footRight, top: footTop, bottom: footBottom } = isFullScreen ? this.option.footFullViewOption : this.option.footViewOption;
      this.state.footViewArea = {
        baseSize,
        isFullScreen,
        left: floatCeil(_w * footLeft),
        top: floatCeil(_h * footTop),
        width: floatCeil(_w * (1 - footLeft - footRight)),
        height: floatCeil(_h * (1 - footTop - footBottom))
      };
      if ([LOADING, ERROR].find(a => status === a) !== undefined) {
        this.observeStatus();
      } else {
        realContext.clearRect(0, 0, realCanvas.width, realCanvas.height);
        realCursorContext.clearRect(0, 0, realCursorCanvas.width, realCursorCanvas.height);
        this.state.mainView && this.state.mainView.resize(this.state.mainViewArea);
        this.state.footView && this.state.footView.resize(this.state.footViewArea);
      }
    }
  }
  _loading() {
    const { realCanvas, realContext, realCursorCanvas, realCursorContext } = this.state;
    realContext.clearRect(0, 0, realCanvas.width, realCanvas.height);
    realCursorContext.clearRect(0, 0, realCursorCanvas.width, realCursorCanvas.height);
    const _loadingImg = new Image();
    const _loading = () => {
      if (this.store.state.status === LOADING) {
        realContext.clearRect(0, 0, realCanvas.width, realCanvas.height);
        realContext.drawImage(_loadingImg, (realCanvas.width - _loadingImg.width) / 2, (realCanvas.height - _loadingImg.height) / 2);
      }
    }
    _loadingImg.onload = _loading;
    _loadingImg.src = loadingIcon;
  }
  _loadErr() {
    const { realCanvas, realContext, realCursorCanvas, realCursorContext } = this.state;
    realContext.clearRect(0, 0, realCanvas.width, realCanvas.height);
    realCursorContext.clearRect(0, 0, realCursorCanvas.width, realCursorCanvas.height);
    if (this.option.errorMsg.type === ERROR_TEXT) {
      const { sizeRatio, fontFamily, color, value } = this.option.errorMsg;
      realContext.font = sizeRatio * this.store.state.baseSize * this.dpr + 'px ' + fontFamily;
      realContext.textAlign = 'center';
      realContext.textBaseline = 'middle';
      realContext.fillStyle = color;
      realContext.fillText(value, realCanvas.width / 2, realCanvas.height / 2);
    }
    // ERROR_IMAGE暂时未用到 rollup报错先注释掉
    // else if (this.option.errorMsg.type === ERROR_IMAGE) {
    //   import('../../assets/image/' + this.option.errorMsg.value).then(({default: source}) => {
    //     const img = new Image();
    //     img.onload = function() {
    //       realContext.drawImage(this, realCanvas.width / 2 - this.width / 2, realCanvas.height / 2 - this.height / 2);
    //     }
    //     img.src = source;
    //   })
    // }
  }
  _calcOffset() {
    this.state.pageX = 0;
    this.state.pageY = 0;
    let ele = this.state.realCursorCanvas;
    while (ele) {
      const { offsetLeft = 0, offsetTop = 0 } = ele;
      this.state.pageX += offsetLeft;
      this.state.pageY += offsetTop;
      ele = ele.offsetParent;
    }
  }
  _panEvent(e) {
    switch (e.type) {
      case 'panend':
      case 'pancancel':
        this._hideCursor();
        break;
      default:
        const isPress = this.store.state.isPress;
        if (isPress) {
          this._validEvent(e).then(r => {
            this._showCursor(r);
          }).catch(err => {
            // this._hideCursor();
          });
        } else {
          // 移动端手势左右滑动先注释掉
          // this.currySwipe(e);
        }
        break;
    }
  }
  _pressEvent(e) {
    const type = e.type;
    if (type == 'press') {
      this._validEvent(e).then(r => {
        this._showCursor(r);
      }).catch(err => {
        this._hideCursor();
      });
    } else {
      this._hideCursor();
    }
  }
  _tapEvent(e) {
    // 点击时十字线不消失
    // const isPress = this.store.state.isPress;
    // if (isPress) {
    //   this._hideCursor();
    // }
    this._validEvent(e).then(r => {
      if (!this.state.status) {
        const { x, y } = r;
        const tapPoint = {
          x: x * this.dpr,
          y: y * this.dpr
        };
        // rst为true, false, undefined
        const rst = this.state.footView.tap(tapPoint);
        if (rst === true) {
          this.store.commit('changeFootState');
        } else if (rst === false) {
          const { footContextKey } = this.store.state;
          // 无权限点击跳转
          this.$emit('tapGraph', {
            module: footContextKey,
            view: 'foot',
            hasAuth: false
          });
        }
        // 主视图不支持tap切换状态
        // this.state.mainView.tap(tapPoint) && this.store.commit('changeMainState');
      }
    }).catch(err => { })
  }
  // 校验坐标有效范围
  // 指标组件和主组件联动时y范围会校验失败，故先注释掉对y轴的校验，且最终定位是用x（可以不需要y坐标）
  async _validEvent(e) {
    try {
      const isFullScreen = this.store.state.isFullScreen;
      let panX, panY;
      // 横竖屏区分计算
      if (isFullScreen) {
        panX = (e && e.changedPointers[0].clientX) || this.store.state.clientX;
      } else {
        panX = (e && e.changedPointers[0].pageX) || this.store.state.pageX;
      }
      const { offsetWidth, offsetHeight } = this.state.realCursorCanvas;
      if (!offsetWidth) {
        return;
      }
      const { transitionMatrix, transformOrigin, position } = this.store.state;
      if (!Util.isArray(transformOrigin) || transformOrigin.length !== 2) {
        return;
      }
      const [originX, originY] = transformOrigin;
      const [clientX, clientY] = position;
      const { pageX, pageY } = this.state;
      // const matrix = Matrix2d.transition(transitionMatrix, [[panX - originX - clientX, panY - originY - clientY, 1]]);
      const matrix = await Matrix2d.transition(transitionMatrix, [[panX - originX - clientX, 1, 1]]);
      panX = matrix[0][0] + clientX + originX;//store里面的position的clientX
      // panY = matrix[0][1] + clientY + originY;
      const x = panX - pageX;
      // const y = panY - pageY;
      // if (x >= 0
      //   && x <= offsetWidth
      //   && y > 0
      //   && y < offsetHeight
      // ) {
      if (x >= 0
        && x <= offsetWidth
      ) {
        this.store.state.xValue = x
        // return Promise.resolve({x, y});
        return Promise.resolve({ x });
      }
      // return Promise.reject('无效区域');
    } catch (e) {
      return Promise.reject(e);
    }
  }
  _hideCursor() {
    this.store.commit('setPress', false);

    const { status } = this.store.state;
    if (status === LOADED) {
      const { realCanvas, realCursorCanvas, realContext, realCursorContext } = this.state;
      realCursorContext.clearRect(0, 0, realCursorCanvas.width, realCursorCanvas.height);
      const footCurrent = this.state.footView && this.state.footView.hideCursor();
      const mainCurrent = this.state.mainView && this.state.mainView.hideCursor();
      if (footCurrent === mainCurrent) {
        this.store.commit('setCurrent', {
          current: footCurrent
        });
      }
    }
  }
  _showCursor({ x, y }) {
    this.code_name = this.store.state.sealObj.prod_name || localStorage.getItem('code_name')
    const { status } = this.store.state;
    if (status === LOADED) {
      const { realCanvas, realCursorCanvas, realContext, realCursorContext } = this.state;
      realCursorContext.clearRect(0, 0, realCursorCanvas.width, realCursorCanvas.height);
      this.store.commit('setPress', true);
      const footX = x * this.dpr - this.state.footViewArea.left;
      const mainX = x * this.dpr - this.state.mainViewArea.left;
      const footCurrent = this.state.footView && this.state.footView.showCursor(footX);
      const mainCurrent = this.state.mainView && this.state.mainView.showCursor(mainX);
      if (footCurrent === mainCurrent) {
        this.store.commit('setCurrent', {
          current: footCurrent
        });
      }
    }
  }
  _swipe(e) {
    const { velocityX, velocityY } = e;
    const { start, end, len, isFullScreen, isVertical } = this.store.state;
    const totalLen = end - start;
    if (len <= totalLen) {
      return;
    }
    let distance = Math.min(Math.max(Math.floor(this.state.ratio * totalLen), 1), 5);
    if (isFullScreen && isVertical) {
      if (velocityY < 0) {
        distance = -distance;
      }
    } else {
      if (velocityX < 0) {
        distance = -distance;
      }
    }
    const newStart = Math.min(Math.max(start - distance, 0), len - totalLen);
    const newEnd = Math.min(Math.max(end - distance, totalLen), len);
    if (start === newStart && end === newEnd) {
      return;
    }
    this.store.commit('setStartAndEnd', {
      start: newStart,
      end: newEnd
    });
  }
  observeGestures() {
    const direction = this.option.hammerOption.pan.direction;
    const { isVertical, isFullScreen } = this.store.state;
    if (isFullScreen) {
      if (direction !== Hammer.DIRECTION_ALL) {
        // 竖屏模式下的全屏图需切换pan方向
        const option = {
          pan: {
            direction: Hammer.DIRECTION_ALL
          }
        };
        this._initGestures(option);
      }
    } else {
      if (direction !== Hammer.DIRECTION_HORIZONTAL) {
        const option = {
          pan: {
            direction: Hammer.DIRECTION_HORIZONTAL
          }
        };
        this._initGestures(option);
      }
    }
  }
  observeSwipe() {
    const { status, start, end, axisX, current } = this.store.state;
    if (status === LOADED) {
      // 由于k线x轴时间及网格在klinefootdectorator中绘制，为避免缩放时后绘制的主视图覆盖纵向网格，此处调整为先绘制主图再绘制辅图
      this.state.mainView && this.state.mainView.swipe({ start, end, current, axisX });
      this.state.footView && this.state.footView.swipe({ start, end, current, axisX });
    }
  }
  observeStatus(args) {
    const { status } = this.store.state;
    this.state.mainView = null;
    this.state.footView = null;
    switch (status) {
      case LOADING:
        this._loading();
        break;
      case ERROR:
        this._loadErr();
        break;
      default:
        // 不展示主视图时，此处去除LOADING下的加载图
        // const { realCanvas, realContext} = this.state;
        // realContext.clearRect(0, 0, realCanvas.width, realCanvas.height);
        // 切换主辅视图进行刷新
        this.changeHandler();
        break;
    }
  }
  changeMainView() {
    const { realContext, realCursorContext, mainViewArea } = this.state;
    const { MAIN_STATUS, ...rest } = this.store.state;
    const { period, mainContextKey, kLineMapKey } = rest;
    const option = { context: realContext, curContext: realCursorContext, dpr: this.dpr, data: rest };
    const mainItem = MAIN_STATUS[period].find(a => a.key === mainContextKey);
    // k线不同类型图谱切换
    if (kLineMapKey) {
      let klineContext;
      switch (kLineMapKey) {
        case 11:
          klineContext = KLINE_US_STATE
          break;
        case 13:
          klineContext = KLINE_AREA_STATE
          break;
        case 12:
          klineContext = KLINE_LINE_STATE
          break;
        // KLINE_CLOSELINE_STATE
        // case 0:
        //   klineContext = KLINE_STATE
        //   break;
        default:
          break;
      }
      this.state.mainView = new klineContext({ ...option, ...mainViewArea });
    }
    else if (mainItem) {
      const mainContext = mainItem.context;
      const mainAuth = !mainItem.noauth;
      this.state.mainView = new mainContext({ ...option, ...mainViewArea, auth: mainAuth });
    }
  }
  changeFootView() {
    const { realContext, realCursorContext, footViewArea } = this.state;
    const { FOOT_STATUS, ...rest } = this.store.state;
    const { period, footContextKey } = rest;
    const option = { context: realContext, curContext: realCursorContext, dpr: this.dpr, data: rest };
    const footItem = FOOT_STATUS[period].find(a => a.key === footContextKey);
    if (footItem) {
      const footContext = footItem.context;
      const footAuth = !footItem.noauth;
      this.state.footView = new footContext({ ...option, ...footViewArea, auth: footAuth });
    }
  }
  destroy() {
    let { realCanvas, realCursorCanvas, realContext, realCursorContext } = this.state;
    if (this.hammerManager) {
      this.hammerManager.destroy();
      this.hammerManager = null;
    }
    if (this.resizeObserve) {
      this.resizeObserve.unobserve(this.ele);
      this.resizeObserve = null;
    }
    realCanvas && this.ele.removeChild(realCanvas);
    realCursorCanvas && this.ele.removeChild(realCursorCanvas);
    realContext = null;
    realCursorContext = null;
    realCanvas = null;
    realCursorCanvas = null;
    if (this.state.mainView) {
      this.state.mainView.destroy();
      this.state.mainView = null;
    }
    if (this.state.footView) {
      this.state.footView.destroy();
      this.state.footView = null;
    }
    this.currySwipe = null;
    this.state = null;
    this.option = null;
    this.ele = null;
  }
  $emit(...args) {
    if (this.parent && this.parent._isVue) {
      this.parent.$emit.apply(this.parent, args);
    }
  }
}
